import React from 'react';
import { Drawer, Table, Typography, Button, Space } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { useNavigate } from 'react-router-dom';

const { Text, Title } = Typography;

export interface SalesAnalyticsDrillDownRow {
  key: string;
  label: string;
  sublabel?: string | null;
  amount?: number | null;
  date?: string | null;
  link_path?: string;
  extra?: Record<string, string | number | null>;
}

export interface SalesAnalyticsDrillDownDrawerProps {
  open: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
  rows: SalesAnalyticsDrillDownRow[];
  formatCurrency?: (n: number) => string;
}

export const SalesAnalyticsDrillDownDrawer: React.FC<SalesAnalyticsDrillDownDrawerProps> = ({
  open,
  onClose,
  title,
  subtitle,
  rows,
  formatCurrency,
}) => {
  const navigate = useNavigate();

  const columns: ColumnsType<SalesAnalyticsDrillDownRow> = [
    {
      title: 'Document',
      key: 'label',
      render: (_: unknown, r) => (
        <div>
          <Text strong>{r.label}</Text>
          {r.sublabel ? (
            <div>
              <Text type="secondary">{r.sublabel}</Text>
            </div>
          ) : null}
        </div>
      ),
    },
    {
      title: 'Date',
      dataIndex: 'date',
      width: 110,
      render: (v: string | null) => v ?? '—',
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      width: 120,
      align: 'right',
      render: (v: number | null | undefined) =>
        v != null && formatCurrency ? formatCurrency(v) : v != null ? String(v) : '—',
    },
    {
      title: '',
      key: 'action',
      width: 80,
      render: (_: unknown, r) =>
        r.link_path ? (
          <Button type="link" size="small" onClick={() => navigate(r.link_path!)}>
            Open
          </Button>
        ) : null,
    },
  ];

  return (
    <Drawer open={open} onClose={onClose} width={640} title={<Title level={5} style={{ margin: 0 }}>{title}</Title>}>
      {subtitle ? (
        <Text type="secondary" style={{ display: 'block', marginBottom: 16 }}>
          {subtitle}
        </Text>
      ) : null}
      <Table size="small" rowKey="key" pagination={{ pageSize: 15 }} dataSource={rows} columns={columns} />
      <Space style={{ marginTop: 12 }}>
        <Button onClick={onClose}>Close</Button>
      </Space>
    </Drawer>
  );
};
